import React from 'react';

import { TrainInfoData, TrainDetails } from '../types';

interface TrainInfoContext extends TrainInfoData {
  onTrainClicked: (TrainDetails: TrainDetails, isMobile: boolean) => void;
}

// https://github.com/typescript-cheatsheets/react-typescript-cheatsheet#context
const TrainInfoContext = React.createContext({} as TrainInfoContext);

export default TrainInfoContext;
